<template>
  <div>
    <!-- 年度开工率 -->
    <Echart
      :options="options"
      id="bottomLeftChart"
      height="280px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data () {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#7B7DDC"
              }
            }
          },
          title: {
            text: '园区设备运行情况',
            textStyle: {
              color: '#c3cbde'
            }
          },
          legend: {
            data: ["运行正常", "正在维护", "故障设备"],
            textStyle: {
              color: "#B4B4B4",
              fontSize: '16'
            },
            top: "0%"
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            data: newData.category,
            axisLine: {
              lineStyle: {
                color: "#B4B4B4"
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: [
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#B4B4B4"
                }
              },

              axisLabel: {
                formatter: "{value} "
              }
            },
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#B4B4B4"
                }
              },
              axisLabel: {
                formatter: "{value} "
              }
            }
          ],
          series: [
            {
              name: "运行正常",
              type: "line",
              smooth: true,
              showAllSymbol: true,
              symbol: "none",
              symbolSize: 8,
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  color: "#F02FC2"
                }
              },
              data: newData.lineData1
            },
            {
              name: "正在维护",
              type: "line",
              smooth: true,
              showAllSymbol: true,
              symbol: "none",
              symbolSize: 8,
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  color: "#B4B4B4"
                }
              },
              data: newData.lineData2
            },
            {
              name: "故障设备",
              type: "line",
              smooth: true,
              showAllSymbol: true,
              symbol: "none",
              symbolSize: 8,
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  color: "#3EACE5"
                }
              },
              data: newData.lineData3
            }
          ]
        }
      },
      immediate: true,
      deep: true
    },
  },
}
</script>